export class Spinner {
	_timeout
	_element

	constructor(targetElement, timeoutSec) {
		this._target = targetElement

		const spinnerElement = document.createElement('div')
		spinnerElement.classList.add('spinner')
		this._element = this._target.appendChild(spinnerElement)
		if (timeoutSec > 0) {
			this._timeout = setTimeout(this.dismiss, timeoutSec * 1000)
		}
	}

	dismiss = () => {
		if (this._timeout) {
			clearTimeout(this._timeout)
			this._timeout = null
		}
		this._element.remove()
	}
}